export default __webpack_public_path__ + "static/media/logo.52cc6b31.jpg";